module.exports = __webpack_public_path__ + "static/media/xls.a2e54ddf.png";